import { render, staticRenderFns } from "./naverIOSReturn.vue?vue&type=template&id=5fd88a43&scoped=true"
import script from "./naverIOSReturn.vue?vue&type=script&lang=js"
export * from "./naverIOSReturn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd88a43",
  null
  
)

export default component.exports